import { useMemo } from 'react'

import { Toggle } from './accordionGroup/Toggle'
import { Vertical } from './accordionGroup/Vertical'
import { IAccordionGroupProps } from './models/IAccordionGroupProps'

export const AccordionGroup = ({
  className,
  margin,
  noPadding,
  items,
  icon,
  contentAlwaysExisting,
  defaultItem,
  urlKey,
  sticky = true,
  classes,
  headerClassName,
  iconOpened,
  bodyClassName,
  viewMode = 'vertical',
}: IAccordionGroupProps) => {
  const visibleItems = useMemo(() => {
    if (!items) {
      return []
    }
    return items.filter((tab) => tab.viewCond === undefined || tab.viewCond)
  }, [items])

  const commonProps = {
    className,
    visibleItems,
    defaultItem,
    urlKey,
  }

  if (viewMode === 'spoilerGroup') {
    return (
      <Toggle
        {...commonProps}
        margin={margin}
        contentAlwaysExisting={contentAlwaysExisting}
        icon={icon}
        iconOpened={iconOpened}
        headerClassName={headerClassName}
        bodyClassName={bodyClassName}
        noPadding={noPadding}
      />
    )
  }

  return <Vertical {...commonProps} classes={classes} sticky={sticky} />
}
